import React from 'react'
import DataGridB from './DataGridB'

const Bodegas = () => {
  return (
    <div>
      <DataGridB />
    </div>
  )
}

export default Bodegas
